import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AuthInitialState } from './auth.state';
import { verifyToken } from 'store/auth/auth.thunk';
import { QueryState, SitePermissionTypes } from '@/common/enum';

const initialState = AuthInitialState;

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    SET_AUTH_USERID: (state, action: PayloadAction<{ userId: number }>) => {
      state.userId = action.payload.userId;
    },
    SET_AUTH_JWT: (state, action: PayloadAction<string>) => {
      state.token = action.payload;
    },
    SET_ACCESS_TYPE: (state, action: PayloadAction<SitePermissionTypes>) => {
      state.accessType = action.payload;
    },
    SET_ERROR_MSG: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
    },
    RESET_AUTH_STATE: () => {
      return initialState;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(verifyToken.pending, (state: AuthTypes) => {
        state.token = null;
        state.tokenVerification = null;
        state.queryState = QueryState.AWAIT;
      })
      .addCase(verifyToken.fulfilled, (state: AuthTypes, action) => {
        state.queryState = QueryState.READY;
        if (action.payload) state.tokenVerification = action.payload;
      })
      .addCase(verifyToken.rejected, (state: AuthTypes, action) => {
        state.queryState = QueryState.FAIL;
        state.error = action.error.message || 'Something went wrong!';
      });
  },
});

export default authSlice.reducer;
